<template>
  <section
    v-loading="loading"
    class="selected-test-preview"
    id="wound-panel-tests-preview"
  >
    <div class="test-panel-name">
      <p class="name">Selected Panels</p>
      <p class="viewPanel" @click="showWoundTests">{{ this.UTIPanels }}</p>
    </div>
    <div class="default-modal" v-if="woundTestsPopup">
      <el-dialog v-model="woundTestsPopup" class="w-60">
        <div class="dialog-header">
          <span class="header-part">RESPIRATORY</span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="woundTestsPopup = false"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li
              class="toxicology-text-panels"
              v-for="(category, index) of getCaseCategoryData('RESPIRATORY_PATHOGEN_PANEL')"
              :key="index"
            >
              <h3 class="test-group-title">
                {{ category.panel_title }}
              </h3>
              <ul class="check-list-gastro">
                <li
                  v-for="(item, index) of getCategoryWiseTestsData(
                    'RESPIRATORY_PATHOGEN_PANEL',
                    category.panel_id,
                     category.group_id
                  )"
                  :key="index"
                >
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";

import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      activeNameCollapse: "",
      UTIPanels: "",
      UTIGroupId: "",
      selectedUTIPanels: [],
      loading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      allTests: "",
      caseRouteNames: [
        "NewCase",
        "Case-Information-Update",
        "NewOrder",
        "Edit-Order-Info",
        "SendOutsView",
        "PendingCasesEdit",
        "Concurrent-Case-Information-Update",
      ],
      woundTestsPopup: false,
    };
  },
  async mounted() {
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;
    this.loading = true;
    try {
      this.getSelectedGroupTitle()
    } catch (err) {
      console.log(err);
    }

    this.testsData = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedTestIds)
    );
    this.selectedCoriellPanels = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedCoriellPanels)
    );
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("cases", ["getCaseInformation", "getCorriellTestPanels"]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
  },
  methods: {
    showWoundTests() {
      this.woundTestsPopup = true;
    },
    
       getCategoryWiseTestsData(caseType, category, group_id) {
      return this.getNewLabGroupPanelTests.filter(
        (el) =>
          el.case_type_code == caseType &&
          el.panel_id == category &&
          el.group_id == group_id
      );
    },
    getCaseCategoryData() {
      let data = this.getNewLabGroupPanelTests.filter((e) =>
        this.UTIGroupId == e.group_id && this.selectedUTIPanels.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },

     getSelectedGroupTitle() {

      let selectedGroup = this.panelsTestsData.selectedGroup.filter((e)=>e.case_type_code =="RESPIRATORY_PATHOGEN_PANEL")
      
      if (selectedGroup.length) {
        const selectedGroupId = selectedGroup[0].group_id;
    
        const matchedGroup = this.getNewLabGroupWiseTests.find(
          (group) => group._id == selectedGroupId
        );
        this.UTIPanels = matchedGroup?.group_title || "No matching group";
        this.UTIGroupId = matchedGroup?.group_id

        if(matchedGroup?.panel_ids && matchedGroup?.panel_ids.length > 0 && typeof(matchedGroup?.panel_ids[0]) == "string"){
        this.selectedUTIPanels = matchedGroup?.panel_ids;
        }else{
          this.selectedUTIPanels = matchedGroup?.panel_ids.map((e)=>e._id)
        }
      }
    }
  },
};
</script>
<style lang="scss">
#wound-panel-tests-preview {
  .el-dialog {
    width: 60% !important;
    margin-top: 7vh;
  }
  .popup-panels-blocks {
    .toxicology-text-panels {
      padding: 10px 0;
      position: relative;
    }

    .toxicology-text-panels:not(:last-child):after {
      content: "";
      position: absolute;
      width: 100%;
      left: 0;
      // border-bottom: 1px solid #e8e4e4;
    }
    .check-list-woundpanel {
      display: grid;
      grid-template-columns: repeat(3, 33.3%);
      -moz-column-gap: 10px;
      column-gap: 10px;
      li {
        margin: 7px 0;

        &:not(:last-child) {
          margin-right: 15px;
        }
      }
      .el-checkbox {
        height: auto;
      }

      .el-checkbox-group {
        .el-checkbox {
          height: 20px;
        }

        .el-checkbox__input .el-checkbox__inner {
          border-color: transparent;
          box-shadow: 0 0 0 1px #ced1d6;
          border-radius: 4px;
          width: 17px;
          height: 17px;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #273480;
          border-color: #ffffff;
          box-shadow: 0 0 0 1px #ced1d6;
          width: 17px;
          height: 17px;
        }
        .el-checkbox__inner::after {
          box-sizing: content-box;
          content: "";
          border: 2px solid var(--el-checkbox-checked-icon-color);
          border-left: 0;
          border-top: 0;
          height: 9px;
          left: 5px;
          position: absolute;
          top: 1px;
          transform: rotate(45deg) scaleY(1);
          width: 3px;
          transition: transform 0.15s ease-in 50ms;
          transform-origin: center;
        }

        .el-checkbox__label {
          color: #34495e;
        }
      }
    }

    .test-group-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 5px;
    }
  }
}
</style>
